import logoImg from '../img/newlogo.png';

// Función para precargar imágenes
const preloadImages = (images) => {
    images.forEach((src) => {
        const img = new Image();
        img.src = src;
    });
};

// Precargar el logo de la aplicación
export const preloadAppImages = () => {
    preloadImages([logoImg]);
};

// Exportar el logo precargado para uso en componentes
export const preloadedLogo = logoImg;

// Iniciar la precarga inmediatamente
preloadAppImages(); 